export default {
  init() {
    console.log('Categories');
  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
